require("!!/Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/node_modules/script-loader/addScript.js")(require("!!/Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/node_modules/raw-loader/index.js!/Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/node_modules/amcharts3/amcharts/pie.js"))


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/script-loader!/Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/amcharts3/amcharts/pie.js
// module id = ../../../../script-loader/index.js!../../../../amcharts3/amcharts/pie.js
// module chunks = 41